import {
    GET_ACTIVE_DEVICES,
} from '../actions/LabolinkActions'

const initialState = {
    devices: []
}

const LabolinkReducer = function (state = initialState, action) {
    switch (action.type) {
        case GET_ACTIVE_DEVICES: {
            return {
                ...state,
                devices: action.payload,
            }
        }
        default: {
            return state
        }
    }
}

export default LabolinkReducer